/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IExternalApiConfigurationControllerScope extends angular.IScope {
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigId: string;

        updateAllMappings: () => void;
        save: () => void;
    }

    export class ExternalApiConfigurationController implements IController {
        constructor(
            private scope: IExternalApiConfigurationControllerScope,
            $routeParams: angular.route.IRouteParamsService,
            private externalApiService: services.ExternalApiService)
        {
            this.scope.processConfigId = $routeParams["id"];

            this.scope.updateAllMappings = () => this.updateAllMappings();
            this.scope.save = () => this.save();

            this.externalApiService.getExternalApiConfiguration(this.scope.processConfigId).then(
                (processConfig) => {
                    this.scope.processConfiguration = processConfig;
                    if (!this.scope.processConfiguration) this.updateAllMappings();
                });
        }

        private updateAllMappings(): void {
            this.externalApiService.updateAllMappings(this.scope.processConfigId).then(() => {
                this.externalApiService.getExternalApiConfiguration(this.scope.processConfigId).then(
                    (processConfig) => this.scope.processConfiguration = processConfig);
            });
        }

        private save(): void {
            this.externalApiService.saveAllChanges();
        }
    }
}

warsApp.registerController('ExternalApiConfigurationController', ["$scope", "$routeParams", "externalApiService"]);